import React from 'react';
import { getDollarFormat, colorCategory } from 'utils/helpers';
import moment from 'moment';
import CategoryIcons from 'library/categoryIcons';

const Body = ({ monthlyProductSales, searchedYear }) => {

    
    return (
        <div>
            <div className="row m-0 list_header">
                <div className="col-lg-6">
                    <h3 className="m-0 p-0">PRODUCT SALES</h3>
                </div>
                <div className="col-lg-6 text-right">
                    <h3 className="m-0 p-0">{searchedYear ? searchedYear : moment().format('YYYY') }</h3>
                </div>
            </div>
            <div className="mt-2">
                {
                    (monthlyProductSales || []).map((i, index) => {
                        const totalQty = i.january + i.february + i.march + i.april + i.may + i.june + i.july + i.august + i.september + i.october + i.november + i.december;
                        const categoryStyle =  {
                            background: {
                                backgroundColor: colorCategory(i.classOfCannabis)
                            },
                            textColor: {
                                color: colorCategory(i.classOfCannabis)
                            }
                        }
                        
                        return(
                            <div className="row m-0 border_bottom_grey mb-2" key={index} >
                                <div className="col-lg-2 mb-1 mt-1 p-0 text-center">
                                        <h3 className="productName m-0 p-0">{i.productName}</h3>
                                        <p className="numberCode"><i>SKU: {i.sku} </i></p>
                                        <div className="mb-3" style={categoryStyle.textColor}>
                                            <CategoryIcons 
                                                type={i.classOfCannabis}
                                                categoryName={i.classOfCannabis}
                                                titleClass="capitalize"
                                                />
                                            <span>{i.classOfCannabis == null ? "Uncategorized, " + i.category : ", " + i.category}</span>
                                        </div>
                                </div>
                                <div className="col-lg-10 m-0 p-0 text-center">
                                    <div className="row m-0">
                                        <div className="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-xs-4 mb-2 p-0">
                                            <label className="border_bottom_grey font-italic">Jan</label>
                                            <h4 className="money">{getDollarFormat(i.january)}</h4>
                                            {<h4>Qty: {Math.round(i.januaryQty)}</h4>}
                                        </div>
                                        <div className="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-xs-4 mb-2 p-0">
                                        <label className="border_bottom_grey font-italic">Feb</label>
                                            <h4 className="money">{getDollarFormat(i.february)}</h4>
                                            {<h4>Qty: {Math.round(i.februaryQty)}</h4>}
                                        </div>
                                        <div className="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-xs-4 mb-2 p-0">
                                            <label className="border_bottom_grey font-italic">Mar</label>
                                            <h4 className="money">{getDollarFormat(i.march)}</h4>
                                            {<h4>Qty: {Math.round(i.marchQty)}</h4>}
                                        </div>
                                        <div className="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-xs-4 mb-2 p-0">
                                            <label className="border_bottom_grey font-italic">Apr</label>
                                            <h4 className="money">{getDollarFormat(i.april)}</h4>
                                            {<h4>Qty: {Math.round(i.aprilQty)}</h4>}
                                        </div>
                                        <div className="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-xs-4 mb-2 p-0">
                                            <label className="border_bottom_grey font-italic">May</label>
                                            <h4 className="money">{getDollarFormat(i.may)}</h4>
                                            {<h4>Qty: {Math.round(i.mayQty)}</h4>}
                                        </div>
                                        <div className="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-xs-4 mb-2 p-0">
                                            <label className="border_bottom_grey font-italic">Jun</label>
                                            <h4 className="money">{getDollarFormat(i.june)}</h4>
                                            {<h4>Qty: {Math.round(i.juneQty)}</h4>} 
                                            
                                        </div>
                                        <div className="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-xs-4 mb-2 p-0">
                                            <label className="border_bottom_grey font-italic">Jul</label>
                                            <h4 className="money">{getDollarFormat(i.july)}</h4>
                                            {<h4>Qty: {Math.round(i.julyQty)}</h4>}
                                        </div>
                                        <div className="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-xs-4 mb-2 p-0">
                                            <label className="border_bottom_grey font-italic">Aug</label>
                                            <h4 className="money">{getDollarFormat(i.august)}</h4>
                                            {<h4>Qty: {Math.round(i.augustQty)}</h4>}
                                        </div>
                                        <div className="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-xs-4 mb-2 p-0">
                                            <label className="border_bottom_grey font-italic">Sep</label>
                                            <h4 className="money">{getDollarFormat(i.september)}</h4>
                                            {<h4>Qty: {Math.round(i.septemberQty)}</h4>}   
                                        </div>
                                        <div className="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-xs-4 mb-2 p-0">
                                            <label className="border_bottom_grey font-italic">Oct</label>
                                            <h4 className="money">{getDollarFormat(i.october)}</h4>
                                            {<h4>Qty: {Math.round(i.octoberQty)}</h4>}
                                        </div>
                                        <div className="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-xs-4 mb-2 p-0">
                                            <label className="border_bottom_grey font-italic">Nov</label>
                                            <h4 className="money">{getDollarFormat(i.november)}</h4>
                                            {<h4>Qty: {Math.round(i.novemberQty)}</h4>}    
                                        </div>
                                        <div className="col-xl-1 col-lg-2 col-md-3 col-sm-3 col-xs-4 mb-2 p-0">
                                            <label className="border_bottom_grey font-italic">Dec</label>
                                            <h4 className="money">{getDollarFormat(i.december)}</h4>
                                            {<h4>Qty: {Math.round(i.decemberQty)}</h4>}
                                        </div>
                                        <div className="col-lg-12 p-0">
                                            <p className="totalQty"><i>TOTAL: <b>{getDollarFormat(totalQty)}</b>{ /*&emsp; Qty: 2,234&ensp;*/}</i></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

export default Body;